import React from 'react';
import {ShareButtons, generateShareIcon} from 'react-share';

const SocialShare = ({ pinterestMedia }) => {

  const {FacebookShareButton, TwitterShareButton, GooglePlusShareButton, LinkedinShareButton, PinterestShareButton} = ShareButtons;

  const FacebookIcon = generateShareIcon('facebook');
  const TwitterIcon = generateShareIcon('twitter');
  const GooglePlusIcon = generateShareIcon('google');
  const LinkedinIcon = generateShareIcon('linkedin');
  const PinterestIcon = generateShareIcon('pinterest');

  const shareUrl = window.location.href;

  return (
    <div className="share">
      <h4>Share this influencer profile</h4>

      <div title="Share on Facebook" className="link-wrapper">
        <FacebookShareButton url={shareUrl} className="link">
          <FacebookIcon size={32} round={true}/>
        </FacebookShareButton>
      </div>

      <div title="Share on Twitter" className="link-wrapper">
        <TwitterShareButton url={shareUrl} className="link">
          <TwitterIcon size={32} round={true}/>
        </TwitterShareButton>
      </div>

      <div title="Share on Google+" className="link-wrapper">
        <GooglePlusShareButton url={shareUrl} className="link">
          <GooglePlusIcon size={32} round={true}/>
        </GooglePlusShareButton>
      </div>

      <div title="Share on LinkedIn" className="link-wrapper">
        <LinkedinShareButton url={shareUrl} className="link">
          <LinkedinIcon size={32} round={true}/>
        </LinkedinShareButton>
      </div>

      <div title="Share on Pinterest" className="link-wrapper">
        <PinterestShareButton url={shareUrl} className="link" media={pinterestMedia}>
          <PinterestIcon size={32} round={true}/>
        </PinterestShareButton>
      </div>
    </div>
  );
};

export default SocialShare;



// WEBPACK FOOTER //
// ./src/components/social-share/index.js